"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
const operation_1 = require("./operation/operation");
const query_1 = require("./query/query");
class VoidRepository {
    get(queryOrId, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
    getAll(queryOrIds, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
    put(value, queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        throw new errors_1.OperationNotSupportedError();
    }
    putAll(values, queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        throw new errors_1.OperationNotSupportedError();
    }
    delete(queryOrId, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
    deleteAll(queryOrIds, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
}
exports.VoidRepository = VoidRepository;
class VoidGetRepository {
    get(queryOrId, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
    getAll(queryOrIds, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
}
exports.VoidGetRepository = VoidGetRepository;
class VoidPutRepository {
    put(value, queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        throw new errors_1.OperationNotSupportedError();
    }
    putAll(values, queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        throw new errors_1.OperationNotSupportedError();
    }
}
exports.VoidPutRepository = VoidPutRepository;
class VoidDeleteRepository {
    delete(queryOrId, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
    deleteAll(queryOrIds, operation) {
        throw new errors_1.OperationNotSupportedError();
    }
}
exports.VoidDeleteRepository = VoidDeleteRepository;
